var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86001 3.07335L1.21335 12.5C1.09693 12.7016 1.03533 12.9302 1.03467 13.163C1.03402 13.3958 1.09434 13.6248 1.20963 13.827C1.32492 14.0293 1.49116 14.1978 1.69182 14.3159C1.89247 14.434 2.12055 14.4975 2.35335 14.5H13.6467C13.8795 14.4975 14.1076 14.434 14.3082 14.3159C14.5089 14.1978 14.6751 14.0293 14.7904 13.827C14.9057 13.6248 14.966 13.3958 14.9654 13.163C14.9647 12.9302 14.9031 12.7016 14.7867 12.5L9.14001 3.07335C9.02117 2.87742 8.85383 2.71543 8.65414 2.603C8.45446 2.49058 8.22917 2.43152 8.00001 2.43152C7.77086 2.43152 7.54557 2.49058 7.34588 2.603C7.1462 2.71543 6.97886 2.87742 6.86001 3.07335Z",
    fill: "#EAB30D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5V9.16667",
    stroke: "#111827",
    strokeWidth: 1.4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.8334H8.0075",
    stroke: "#111827",
    strokeWidth: 1.4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.77562215.svg";
export { ForwardRef as ReactComponent };